import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
// import Particles from "react-tsparticles"; // rimosso: non usato
import { getAuthorizationUrl } from '../utils/auth';
import './LoginPage.css';
import TestBubblesCSS from './TestBubblesCSS';
import './TestBubbles.css';

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      // Test storage before proceeding
      console.log('Testing storage before login...');
      const testKey = 'test_storage_' + Date.now();
      const testValue = 'test_value_' + Math.random();
      try {
        localStorage.setItem(testKey, testValue);
        const retrieved = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        if (retrieved !== testValue) {
          throw new Error('localStorage test failed');
        }
        console.log('localStorage test passed');
      } catch (storageError) {
        console.error('localStorage test failed:', storageError);
        alert('Browser storage is not working. Please check your browser settings and try again.');
        setIsLoading(false);
        return;
      }
      console.log('Current localStorage state before redirect:', {
        oauth_state: localStorage.getItem('oauth_state'),
        pkce_state: localStorage.getItem('pkce_state'),
        pkce_code_verifier: localStorage.getItem('pkce_code_verifier')
      });
      // Redirect to WSO2 IS
      const authUrl = await getAuthorizationUrl();
      window.location.href = authUrl;
    } catch (error) {
      console.error('Error generating authorization URL:', error);
      setIsLoading(false);
      alert('Failed to initiate login. Please try again.');
    }
  };

  return (
    <div className="login-page" style={{position: 'relative', minHeight: '100vh', overflow: 'hidden', background: 'transparent'}}>
      <TestBubblesCSS hideText={true} />
      <Header />
      <div className="login-container" style={{position: 'relative', zIndex: 2}}>
        <div className="login-card">
          <h1>Welcome!</h1>
          <p>Please login to access the application</p>
          <button 
            className={`login-button ${isLoading ? 'loading' : ''}`} 
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'Preparing login...' : 'Login with WSO2 Identity Server'}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginPage;
